import * as React from "react";
import Axios from "axios";
import { useParams } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../Layout/Loading/Spinner";

/*import * as animationGameStart from "../GameAnimation/Start.json";
import * as animationGameWin1 from "../GameAnimation/Win_1.json";
import * as animationGameWin2 from "../GameAnimation/Win_2.json";
import * as animationGameFail1 from "../GameAnimation/Fail_1.json";
import * as animationGameFail2 from "../GameAnimation/Fail_2.json";
import * as animationGameFail3 from "../GameAnimation/Fail_1.json";
*/
import * as animationGameStart from "../GameAnimation/Start.json";
import * as animationGameWin1 from "../GameAnimation/Win_1.json";
//import * as animationGameWin2 from "../GameAnimation/Win_2.json";
import * as animationGameFail1 from "../GameAnimation/Fail_1.json";
import * as animationGameFail2 from "../GameAnimation/Fail_3.json";
//import * as animationGameFail3 from "../GameAnimation/Fail_1.json";

import Lottie from "lottie-react";
import {
  Box,
  //Container,
  //Paper,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

import Layout from "../Layout/Layout";
import { useTranslation } from "react-i18next";

import "./BiggyDunkTank.css";
//import { playBall } from "@mui/icons-material";

async function getGamePlay(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    let result = await Axios.post(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/gamification/game_biggy_dunk_tank`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
          //"x-access-token": process.env.REACT_APP_TOKEN,
        },
      }
    );
    //console.log(result);
    return result.data;
  } catch (error) {
    console.log(`bigc-line-coupon-web: ${error}`);
    return {
      status: "failed",
      message: error.message,
    };
  }
}

async function insertGameAction(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    let result = await Axios.post(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/gamification_play/insert`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
          //"x-access-token": process.env.REACT_APP_TOKEN,
        },
      }
    );
    //console.log(result);
    return result.data;
  } catch (error) {
    console.log(`bigc-line-coupon-web: ${error}`);
    return {
      status: "failed",
      message: error.message,
    };
  }
}

async function updateGameAction(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    let result = await Axios.post(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/gamification_play/update`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
          //"x-access-token": process.env.REACT_APP_TOKEN,
        },
      }
    );
    //console.log(result);
    return result.data;
  } catch (error) {
    console.log(`bigc-line-coupon-web: ${error}`);
    return {
      status: "failed",
      message: error.message,
    };
  }
}

async function getReceiveReward(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    let result = await Axios.post(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/reward/receive_reward`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
          //"x-access-token": process.env.REACT_APP_TOKEN,
        },
      }
    );
    return result.data;
  } catch (error) {
    console.log(`bigc-line-coupon-web: ${error}`);
    return {
      status: "failed",
      message: error.message,
    };
  }
}

const randomNumberInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

async function randomWin(gameRoundWin) {
  try {
    let result = [];
    if (gameRoundWin === 3) {
      result = [1, 2, 3];
    } else if (gameRoundWin === 2) {
      switch (randomNumberInRange(1, 3)) {
        case 1:
          result = [1, 2];
          break;
        case 2:
          result = [1, 3];
          break;
        default:
          result = [2, 3];
          break;
      }
    } else {
      result[0] = randomNumberInRange(1, 3);
    }
    return result;
  } catch (error) {
    console.log(`bigc-line-coupon-web: ${error}`);
  }
}
/*
const getData = async (filePath, fileType) => {
  try{ 
      const response = await fetch(filePath);
      switch (fileType.toUpperCase()) {
          case 'JSON':
             return response.json();
          default:
             return response;
      }
  } catch (error) {
      return error;
  }
}*/

export default function BiggyDunkTank() {
  const { game_id } = useParams();
  let { lang } = useParams();

  const { t } = useTranslation();

  const [isLang, setIsLang] = React.useState("en");
  const [gameAction, setGameAction] = React.useState("start");
  const lottieRef = React.useRef();
  const [gameAnimation, setGameAnimation] = React.useState(animationGameStart);
  //const [gameAnimation, setGameAnimation] = React.useState('https://storage.googleapis.com/public-image-bigc-line/game_animation/BiggyDunkTank/Win_1.json');
  const [gameAnimationLoop, setGameAnimationLoop] = React.useState(true);
  const [btnPlay, setBtnPlay] = React.useState("/game-img/btn_on_ball.jpg");

  const [playResult, setPlayResult] = React.useState([]);
  const [gamePlay, setGamePlay] = React.useState([]);
  const [gameReward, setGameReward] = React.useState([]);
  const [GameRoundlimit, setGameRoundlimit] = React.useState(1);
  const [playBall, setPlayBall] = React.useState(1);
  const [countPlayWin, setCountPlayWin] = React.useState(0);
  const [RoundWin, setRoundWin] = React.useState([]);

  const [diaplayScore1, setDiaplayScore1] = React.useState(
    "/game-img/score_empty.png"
  );
  const [diaplayScore2, setDiaplayScore2] = React.useState(
    "/game-img/score_empty.png"
  );
  const [diaplayScore3, setDiaplayScore3] = React.useState(
    "/game-img/score_empty.png"
  );

  const [diaplayBall1, setDiaplayBall1] = React.useState(
    "/game-img/score_empty.png"
  );
  const [diaplayBall2, setDiaplayBall2] = React.useState("/game-img/ball.png");
  const [diaplayBall3, setDiaplayBall3] = React.useState("/game-img/ball.png");

  const [actionCoupon, setActionCoupon] = React.useState([]);
  const [alignment, setAlignment] = React.useState("barcode");
  const [qr, setQr] = React.useState("");
  const [responseStatus, setResponseStatus] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [logsPlayId, setLogsPlayId] = React.useState("");
  const [disabledBtn, setDisabledBtn] = React.useState(false);
  //const [open, setOpen] = React.useState(true);

  const [innerWidth, setInnerWidth] = React.useState(window.innerWidth);
  let navigate = useNavigate();
  //let dispatch = useDispatch();
  const userId = sessionStorage.getItem("userId");

  React.useEffect(() => {
    async function fetchData() {
      //const response = await getData('../GameAnimation/Start.json', 'json');
      //console.log(response);

     /* fetch("../GameAnimation/Start.json")
    .then((res) => res.json())
    .then((videos) => videos.filter((video) => {
      return video.id === videoID;
    }))
    .then((matched) => setVideo(matched[0]));
    */
      //check Play
      await setIsLang(sessionStorage.getItem("lang"));

      const gamePlayResult = await getGamePlay({
        game_id: game_id,
        profile_id: userId,
      });
      await setPlayResult(gamePlayResult);

      if (gamePlayResult.status === "success") {
        await setGamePlay(gamePlayResult.data);

        if (gamePlayResult.data.game_result === "play_limit") {
          //console.log('play_limit');
          await setOpen(true);
        } else {
          // Stamp Logs
          const actionLogs = await insertGameAction({
            game_id: game_id,
            profile_id: userId,
          });
          if (actionLogs.status === "success") {
            setLogsPlayId(actionLogs.data.id);

            //await setGameReward(gamePlayResult.data.game_reward);
            await setGameRoundlimit(gamePlayResult.data.game_round_limit);

            if (gamePlayResult.data.game_result === "win") {
              await setRoundWin(
                await randomWin(gamePlayResult.data.game_round_win)
              );
            }
          }
        }
      } else {
        await setOpen(true);
      }
    }
    fetchData();
  }, []);

  const handleClickStart = (e) => {
    e.preventDefault();
    //setTimeout(async () => {
      setGameAnimationPlay(playBall);
      //},1000);

      setGameAction("play");
      setDisabledBtn(true);
      setBtnPlay("/game-img/btn_empty_ball.jpg");

      setGameAnimationLoop(false);
      return false;
   
    //game_round_limit

    //setGameAnimation

    //lottieRef.current.play();
  };
  const handleResultGame = (e) => {
    //e.preventDefault();
    setTimeout(async () => {
      let nextPlay = true;
      //await setActionCoupon(value);
      if (RoundWin.indexOf(playBall) > -1) {
        const countWin = countPlayWin + 1;
        setCountPlayWin(countWin);
        if (countWin === 1) {
          setDiaplayScore1("/game-img/score.png");
        }
        if (countWin === 2) {
          setDiaplayScore2("/game-img/score.png");
        }
        if (countWin === 3) {
          setDiaplayScore3("/game-img/score.png");
        }

        //popup
        if (countWin === gamePlay.game_round_win) {
          //receiveReward
          //console.log(gamePlay);
          //console.log(gamePlay.game_reward.id);

          const receiveReward = await getReceiveReward({
            reward_id: gamePlay.game_reward.id,
            game_id: game_id,
            profile_id: userId,
          });
          //console.log(receiveReward);
          if (receiveReward.status === "success") {
            await setGameReward(receiveReward.data[0]);
            // Stamp Logs lose
            await updateGameAction({
              id: logsPlayId,
              play_result: "win",
              my_reward_id: receiveReward.data.id,
            });
          }
          nextPlay = false;
          handlePopup(e);
        } else {
          nextPlay = true;
        }
      } else if (playBall === GameRoundlimit) {
        // Stamp Logs lose
        await updateGameAction({
          id: logsPlayId,
          play_result: "lose",
        });
        handlePopup(e);
        nextPlay = false;
      } else {
        nextPlay = true;
      }

      if (nextPlay === true) {
        const nextBall = playBall + 1;
        setPlayBall(nextBall);
        setDisabledBtn(false);
        setBtnPlay("/game-img/btn_on_ball.jpg");

        setGameAnimation(animationGameStart);
        setGameAnimationLoop(true);
        setGameAction("start");
        if (nextBall === 2) {
          setDiaplayBall2("/game-img/score_empty.png");
        }
        if (nextBall === 3) {
          setDiaplayBall3("/game-img/score_empty.png");
        }
      }
    }, 0);
  };

  const setGameAnimationPlay = (isBall) => {
    if (RoundWin.indexOf(isBall) > -1) {
      ///Animation Win
      setGameAnimation(animationGameWin1);
      /*
      const aNum = randomNumberInRange(1, 3);
      if (aNum === 1) {
        setGameAnimation(animationGameWin1);
      } else {
        setGameAnimation(animationGameWin2);
      }*/
    } else {
      ///Animation lose
      const aNum = randomNumberInRange(1, 3);
     if (aNum === 1) {
        setGameAnimation(animationGameFail1);
      }else {
        setGameAnimation(animationGameFail2);
      }
       /*else if (aNum === 2) {
        setGameAnimation(animationGameFail2);
      } else {
        setGameAnimation(animationGameFail3);
      }*/
    }
  };

  const handlePopup = (e) => {
    //e.preventDefault();
    setTimeout(() => {
      //await setActionCoupon(value);
      setOpen(true);
      //setGameAction("start");
    }, 1000);
  };

  const handleClose = (e, reason) => {
    e.preventDefault();
    if (reason && reason === "backdropClick") {
      return;
    }

    setOpen(false);
    //setGameAction("start");
    //lottieRef.current.play();
  };

  const handleMyReward = (e, lang) => {
    e.preventDefault();
    window.location.href = `/${lang}/my-reward`;
  };

  const handleMyRewardWin = (e, lang) => {
    e.preventDefault();
    window.fbq('trackCustom', 'accept_my_reward300');
    window.ttq.track('AddToCart');
    window.location.href = `/${lang}/my-reward`;
  };

  const handleEnd = (e, lang) => {
    e.preventDefault();
    window.location.href = `/${lang}/lobby`;
  };

  const handleEndToMyReward = (e, lang) => {
    e.preventDefault();
    window.location.href = `/${lang}/my-reward`;
  };

  return (
    <Layout>
      <Box sx={{ minHeight: 800, width: "100%", boxShadow: "none" }}>
        <Box sx={{ m: 2 }}>
          {playResult.status === "success" &&
          gamePlay.game_result != "play_limit" ? (
            <Grid container spacing={1}>
              <Grid item sm={12} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <Typography variant="h5">
                  {t("game_name_1")}<br/>
                  {t("game_name_2")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item sm={12} xs={12}>
                <Card sx={{ height: "100%", boxShadow: 0, borderRadius: 2 }}>
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <Box className="dunkTank-box-game">
                        {/*gameAction === "start" ? (
                          <Lottie
                            lottieRef={lottieRef}
                            animationData={animationGameStart}
                            loop={true}
                            onComplete={(e) => handleResultGame(e)}
                            //onComplete={(e) => handlePopup(e)}
                          />
                        ) : (
                          ""
                        )}
                        {gameAction === "play" ? (
                          <Lottie
                            lottieRef={lottieRef}
                            animationData={gameAnimation}
                            loop={false}
                            onComplete={(e) => handleResultGame(e)}
                            //onComplete={(e) => handlePopup(e)}
                          />
                        ) : (
                          ""
                        )*/}
                        <Lottie
                          lottieRef={lottieRef}
                          renderer="svg"
                          animationData={gameAnimation}
                          loop={gameAnimationLoop}
                          onComplete={(e) => handleResultGame(e)}
                          //onComplete={(e) => handlePopup(e)}
                        />
                        {gamePlay.game_result != "play_limit" ? (
                          <Box className="dunkTank-button-game">
                            <Box
                              className="dunkTank-point"
                              sx={{
                                backgroundImage:
                                  "url(/game-img/box_score_3.png)",
                              }}
                            >
                              <Box
                                component="img"
                                src={diaplayScore1}
                                className="dunkTank-point-img"
                                sx={{
                                  marginLeft: "10px",
                                }}
                              />
                              <Box
                                component="img"
                                src={diaplayScore2}
                                className="dunkTank-point-img"
                                sx={{
                                  marginLeft: "5px",
                                }}
                              />
                              <Box
                                component="img"
                                src={diaplayScore3}
                                className="dunkTank-point-img"
                                sx={{
                                  marginLeft: "5px",
                                }}
                              />
                            </Box>

                            <Box className="dunkTank-btn-start-game">
                              {/*<Box
                                className="dunkTank-btn-play-game"
                                sx={{
                                  color: "#fff",
                                  backgroundImage: `url(${btnPlay})`,
                                }}
                                disabled={disabledBtn}
                                onClick={(e) => handleClickStart(e)}
                              ></Box>*/}
                              <Button
                                sx={{
                                  color: "#fff",
                                  backgroundImage: `url(${btnPlay})`,
                                }}
                                disabled={disabledBtn}
                                onClick={(e) => handleClickStart(e)}
                              ></Button>

                              <Box
                                sx={{
                                  color: "#fff",
                                  backgroundImage: `url(/game-img/btn_empty_ball.jpg)`,
                                  display: "none",
                                }}
                              ></Box>
                            </Box>
                            <Box
                              className="dunkTank-ball"
                              sx={{
                                backgroundImage:
                                  "url(/game-img/box_ball_3.png)",
                              }}
                            >
                              <Box
                                component="img"
                                src={diaplayBall1}
                                className="dunkTank-ball-img"
                                sx={{
                                  marginLeft: "10px",
                                }}
                              />
                              <Box
                                component="img"
                                src={diaplayBall2}
                                className="dunkTank-ball-img"
                                sx={{
                                  marginLeft: "5px",
                                }}
                              />
                              <Box
                                component="img"
                                src={diaplayBall3}
                                className="dunkTank-ball-img"
                                sx={{
                                  marginLeft: "5px",
                                }}
                              />
                            </Box>
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item sm={12} xs={12}>
                <Box className="game-guide">
                  <Box className="game-guide-how-to-play">
                    <Typography variant="h6" className="how-to-play-detail">
                      {t("how_to_play")}
                    </Typography>
                  </Box>
                  <Box className="game-guide-how-to-play-detail">
                    <Grid container spacing={1}>
                      <Grid item xs={4} sm={4}>
                        <CardMedia
                          className="how-to-play-img"
                          component="img"
                          image="/game-img/how_to_tank_ball.png"
                        />
                      </Grid>
                      <Grid item xs={8} sm={8}>
                        <Typography
                          variant="body"
                          className="how-to-play-detail"
                        >
                          {t("biggy_dunk_tank_step_1")}<br/>
                          {t("biggy_dunk_tank_step_2")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={1}>
              <Grid item sm={12} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Box className="dunkTank-box-game">
                    <Box className="box-loading">
                      <LoadingSpinner />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          )}
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="body"
      >
        {/*<DialogTitle id="alert-dialog-title" sx={{}}>
          <CloseIcon
            sx={{
              color: "#FFF",
              cursor: "pointer",
              right: "5px",
              mt: "-15px",
              width: "30px",
              position: "absolute",
              fontWeight: "bold",
              fontSize: "3rem",
            }}
            onClick={handleClose}
          />
          </DialogTitle>*/}

        <DialogContent className="box-award-dialog">
          {playResult.status === "success" ? (
            gamePlay.game_result === "win" ? (
              <Grid container spacing={1}>
                <Grid item sm={12} xs={12}>
                  <CardMedia
                    className="box-award-img"
                    component="img"
                    image={
                      lang === "cn"
                        ? gameReward.reward_cover_cn
                        : gameReward.reward_cover_en
                    }
                    alt="reward"
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <Box className="box-award-detail">
                    <Typography variant="h6" component="div">
                      {t("win_award")}
                    </Typography>
                    <Typography variant="h6" className="award-name">
                      {lang === "cn"
                        ? gameReward.reward_name_cn
                        : gameReward.reward_name_en}
                    </Typography>

                    <Typography variant="body" className="award-detail">
                      {lang === "cn"
                        ? gameReward.reward_detail_cn
                        : gameReward.reward_detail_en}
                    </Typography>

                    <Box className="btn-award">
                      <Button
                        id="btn-accept-coupon-game"
                        sx={{ color: "#fff" }}
                        onClick={(e) => handleMyRewardWin(e, lang)}
                      >
                        {t("btn_Reward")}
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            ) : gamePlay.game_result === "play_limit" ? (
              <Grid container spacing={1}>
                <Grid item sm={12} xs={12}>
                  <CardMedia
                    className="box-award-img"
                    component="img"
                    image="/img/biggy.png"
                    alt="biggy"
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <Box className="box-award-detail">
                    <Typography variant="h6" component="div">
                      {t("alert_limit_play")}
                    </Typography>
                    <Typography variant="body" component="div">
                      {t("thank_for_play")}
                    </Typography>
                    <Typography variant="body" component="div">
                      {t("can_use_coupon")}
                    </Typography>
                    <Typography variant="body" component="div">
                      {t("to_reward")}
                    </Typography>

                    <Box className="btn-award">
                      <Button
                        id="btn-result-limit"
                        sx={{ color: "#fff" }}
                        onClick={(e) => handleMyReward(e, lang)}
                      >
                        {t("btn_Reward")}
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={1}>
                <Grid item sm={12} xs={12}>
                  <CardMedia
                    className="box-award-img"
                    component="img"
                    image="/img/biggy.png"
                    alt="biggy"
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <Box className="box-award-detail">
                  <Typography variant="h6" component="div">
                      {t("alert_lose")}<br/>
                      {t("alert_lose2")}
                    </Typography>
                    <Typography variant="body" component="div">
                      {t("thank_for_play")}
                    </Typography>
                    <Typography variant="body" component="div">
                      {t("can_use_coupon")}
                    </Typography>
                    <Typography variant="body" component="div">
                      {t("to_reward")}
                    </Typography>

                    <Box className="btn-award">
                      <Button
                        id="btn-result-lose"
                        sx={{ color: "#fff" }}
                        onClick={(e) => handleMyReward(e, lang)}
                      >
                        {t("btn_Reward")}
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            )
          ) : (
            <Grid container spacing={1}>
              <Grid item sm={12} xs={12}>
                <CardMedia
                  className="box-award-img"
                  component="img"
                  image="/img/biggy.png"
                  alt="biggy"
                />
              </Grid>
              <Grid item sm={12} xs={12}>
                <Box className="box-award-detail">
                  {/*
                  <Typography variant="h6" className="award-name">
                    Sorry Game Error
                  </Typography>*/}
                  <Typography variant="h6" component="div">
                    {t("thank_for_play")}
                  </Typography>
                  <Typography variant="body" component="div">
                    {t("can_use_coupon")}
                  </Typography>
                  <Typography variant="body" component="div">
                    {t("to_reward")}
                  </Typography>
                  <Box className="btn-award">
                    <Button
                      id="btn-result-game-failed"
                      sx={{ color: "#fff" }}
                      onClick={(e) => handleMyReward(e, lang)}
                    >
                      {t("btn_Reward")}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
